/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "delivery-pricing-bulk-import",
	data() {
		return {
			importWizard: {
				stepNumber: 1,
				resetWizard: false,
				wizardHeadings: ["Upload", "Import Confirmation", "Import"],
				submitting: false,
				skipSubmissionForCurrentWizardPanel: false, // set to true only if current tab is not calling api
				canMoveOnToNextPanel: false, //make false by default if we are going to do a submission
				importFailed: false,
				isOnImportStep: false,
				importApplicationsModalId: "#importApplicationsModal"
			},
			fileUpload:{
				file: null,
				errorMessage: null,
				name: "Choose File"
			},
			importConfirmation:{
				canSubmit: false,
				productsToImport: [],
				effectiveDate: new Date(),
				validationSuccess: false,
				productZonePriceBulkImport: [],
			},
			importingPricing: false,
			importErrorMessage: {
				message: null,
				show: false
			},
			importSuccessMessage: {
				message: null,
				show: false
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		onFileAttach(event){
			if(event.target.files !== null && event.target.files.length > 0){
				this.fileUpload.file = event.target.files[0];
			}
			else{
				this.fileUpload.file = null;
			}
			console.log("file", this.fileUpload.file);
			if(this.fileUpload.file === null){
				this.importWizard.canMoveOnToNextPanel = false;
				this.fileUpload.name = "Choose File";
			}
			else{
				this.importWizard.canMoveOnToNextPanel = true;
				this.fileUpload.name = this.fileUpload.file.name;
			}
		},
		uploadFile(){
			this.importWizard.submitting = true;
			var formData = new FormData();
			formData.append("file", this.fileUpload.file);
			productService.extractDeliveryZonalPricing(formData).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if (isSuccess) {
						this.importConfirmation.productsToImport = successResponse.data.productsToImport;
						this.importConfirmation.effectiveDate = successResponse.data.effectiveDate;
						console.log("effective date", successResponse.data.effectiveDate);
						this.importWizard.canMoveOnToNextPanel = true;
					}
					this.importWizard.submitting = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					this.importWizard.submitting = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
			// setTimeout(function (){
			// 	self.importWizard.submitting = false;
			// 	self.importWizard.canMoveOnToNextPanel = true;
			// }, 2000);
		},
		onEffectiveDateChange(){
			// if(!this.importConfirmation.validationSuccess){
			// 	this.importWizard.canMoveOnToNextPanel = false;
			// }
			this.importWizard.canMoveOnToNextPanel = true;
		},
		onConfirmationSubmitComplete(confirmation){
			this.importWizard.submitting = false;
			this.importConfirmation.canSubmit = false;
			console.log("success", confirmation.success);
			this.importConfirmation.validationSuccess = confirmation.success;
			this.importConfirmation.productZonePriceBulkImport = confirmation.productZonePriceBulkImport;
			//this.importConfirmation.effectiveDate = confirmation.effectiveDate;
			if(confirmation.success){
				this.importConfirmation.effectiveDate = confirmation.effectiveDate;
				this.importWizard.canMoveOnToNextPanel = true;
			}
			else{
				//this.importConfirmation.canSubmit = true;
				this.importWizard.canMoveOnToNextPanel = false;
			}
		},
		onImportWizardStepCompleteNext(step){
			this.importWizard.resetWizard = false;
			//this.importWizard.skipSubmissionForCurrentWizardPanel = true;
			console.log("step", step);
			//this.startImportValidation = false;
			// if (step === 2){
			// 	this.importWizard.skipSubmissionForCurrentWizardPanel = true;
			// }
			// else{
			// 	this.importWizard.skipSubmissionForCurrentWizardPanel = false;
			// }
			//this.importWizard.canMoveOnToNextPanel = false;
			if(step === 3){
				this.importWizard.submitting = true;
				this.importPricing();
			}
			// if (step === 3) {
			// 	this.importWizard.submitting = true;
			// 	//this.setApplicationsToAddFromCsvFile();
			// }
			// if(step === 4){
			// 	this.importWizard.submitting = true;
			// 	this.importApplicationsInBulk();
			// }
		},
		onImportWizardStepCompletePrevious(step){
			this.importWizard.resetWizard = false;
			//this.startImportValidation = false;
			//this.importWizard.skipSubmissionForCurrentWizardPanel = true;
			this.importWizard.canMoveOnToNextPanel = true;
			console.log("step", step);
			if(step === 1){
				if(this.fileUpload.file === null){
					this.importWizard.canMoveOnToNextPanel = false;
					this.fileUpload.name = "Choose File";
				}
			}
			// if(step === 2){
			// 	if(!this.importConfirmation.validationSuccess){
			// 		this.importWizard.canMoveOnToNextPanel = false;
			// 	}
			// }
			// if (step === 2){
			// 	this.importWizard.skipSubmissionForCurrentWizardPanel = true;
			// }
			// else{
			// 	this.importWizard.skipSubmissionForCurrentWizardPanel = false;
			// }
		},
		submitCurrentImportWizardForm(step){
			//this.importWizard.canMoveOnToNextPanel = true;
			this.importWizard.canMoveOnToNextPanel = false;
			// this.startImportValidation = false;
			if (step === 1) {
				this.importWizard.submitting = true;
				//this.csvUpload.beginUpload = true;
				this.uploadFile();
			}
			if(step === 2){
				this.importWizard.submitting = true;
				this.importConfirmation.canSubmit = true;
			}
			// if(step === 3){
			// 	this.importWizard.submitting = true;
			// 	this.importPricing();
			// }
		},
		importPricing(){
			this.importingPricing = true;
			this.importWizard.canMoveOnToNextPanel = false;
			let request = {
				effectiveDate: this.importConfirmation.effectiveDate,
				productZonePriceBulkImport: this.importConfirmation.productZonePriceBulkImport
			};
			productService.zoneProductBasePriceBulkImport(request).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.importWizard.submitting = false;
						this.importWizard.canMoveOnToNextPanel = true;
						this.importingPricing = false;
						this.importSuccessMessage.show = true;
						this.importSuccessMessage.message = "Import successful";
						localStorage.removeItem(localStorageCacheHelper.localStorageKey.zonesKey);
					}
				},
				errorResponse =>{
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
			// var self = this;
			// self.importWizard.canMoveOnToNextPanel = false;
			// setTimeout(function (){
			// 	self.importWizard.submitting = false;
			// 	self.importWizard.canMoveOnToNextPanel = true;
			// 	self.importingPricing = false;
			// 	self.importSuccessMessage.show = true;
			// 	self.importSuccessMessage.message = "Import successful";
			// }, 1000);
		},
		importDone(){
			this.importWizard.resetWizard = false;
			this.$router.go(-1);
			this.clearImportFields();
		},
		clearImportFields(){
			this.importWizard.stepNumber = 1;
			this.importWizard.importFailed = false;
			this.importWizard.resetWizard = true;
			this.importWizard.skipSubmissionForCurrentWizardPanel = false;
			
			this.fileUpload = {
				file: null,
				errorMessage: null,
				name: "Choose File"
			};
			
			this.importConfirmation = {
				canSubmit: false
			};
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Bulk Import");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Delivery"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Bulk Import"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		// this.getProducts();
		
	}
};